import React from 'react';

const Alert = props => {
    let alertClasses = ['alert'];

    /**
     * Alert types: 
     * alert-success, alert-info-, alert-warning, alert-danger
     */
    if (props.type)
        alertClasses.push(props.type);

    return (
        <div className={alertClasses.join(' ')}>
            <div className="text-box open">
                <a href="/#" className="close" data-dismiss="alert">&times;</a>
                {props.children}
                <div className="close_btn_block text-center">
                    <button type="close" className="close_btn" id="close_btn" data-dismiss="alert"> 關 閉 </button>
                </div>
            </div>
        </div>
    );
}

export default Alert;